import { createContext, useContext } from 'react';

/**
 * The conditions the entry currently on screen declares (issue 36, phase 4b).
 *
 * A context rather than a prop because the prose that mentions a condition is
 * rendered by `RichText`, three levels below the page that knows which entry is
 * open — `GenericDetail` → `DetailSection` → `RichText`. Threading a prop
 * through `DetailSection` would put an entry-shaped concern into the generic
 * section renderer, which is deliberately entry-agnostic.
 *
 * Empty by default, so every other caller of `RichText` (and every test that
 * renders one) behaves exactly as it did before this existed.
 */
const ConditionTermsContext = createContext([]);

export const ConditionTermsProvider = ConditionTermsContext.Provider;

export function useConditionTerms() {
  return useContext(ConditionTermsContext) || [];
}

export default ConditionTermsContext;
